import { useLottiePlayer, useSearchParams } from '@starsoft/common/hooks';
import styles from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';
import { Button, ErrorCard, Progress } from '@starsoft/common/components';
import Link from '@/components/core/Link';
import { AxiosError } from 'axios';
import { GenericError } from '@starsoft/common/models';
import WithdrawRolloverRequiredSkeleton from './Skeleton';
import { WalletService } from '@starsoft/common/services';
import { useAccountByCoin } from '@starsoft/common/api/account/queries';
import { useVerifyRolloverByCoinId } from '@/api/rollover/queries/useVerifyRolloverByCoinId';
import { parseToBigInt } from '@starsoft/common/utils/parsers';
import { getMoneyOrAmount } from '@starsoft/common/utils';

export default function WithdrawRolloverRequired() {
  const { t } = useTranslation('common');
  const params = useSearchParams();
  const coinId = params.get('coin_id');

  const {
    data: account,
    isLoading: isLoadingCoin,
    error: errorCoin,
    refetch: refetchCoin,
  } = useAccountByCoin({
    coinId: coinId ? (parseToBigInt(coinId) as string) : undefined,
    enabled: !!coinId,
  });
  const {
    data: withDrawVerify,
    isLoading,
    error,
    refetch,
  } = useVerifyRolloverByCoinId({
    coinId: coinId ? (parseToBigInt(coinId) as bigint) : undefined,
    enabled: !!coinId,
  });

  const { lottieAnimationRef } = useLottiePlayer({
    path: '/pig.json',
    dependecyArray: [isLoadingCoin, isLoading],
  });

  const currentError = (error ?? errorCoin) as AxiosError<GenericError>;

  function handleError() {
    if (errorCoin) {
      refetchCoin();
    }

    if (error) {
      refetch();
    }
  }

  if (currentError) {
    return (
      <div className={styles.container}>
        <ErrorCard error={currentError} refetch={handleError} />
      </div>
    );
  }

  if (isLoadingCoin || isLoading) {
    return <WithdrawRolloverRequiredSkeleton />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.container__lottie} ref={lottieAnimationRef} />
      <div className={styles.container__wrapper}>
        <div className={styles.container__wrapper__title}>
          {t('cant_withdraw_label')}
        </div>
        <div className={styles.container__wrapper__description}>
          {t('cant_withdraw_description')}
        </div>
      </div>
      <div className={styles.container__wrapper__factor}>
        {WalletService.maskCurrency({
          amount: getMoneyOrAmount(withDrawVerify?.betAmount),
          coin: account?.coin,
        })}
        /
        {WalletService.maskCurrency({
          amount: getMoneyOrAmount(withDrawVerify?.neededAmount),
          coin: account?.coin,
        })}
      </div>
      <Progress
        size="large"
        progress={withDrawVerify?.percentage?.toNumber()}
      />
      <Link href="/casino">
        <Button>{t('verify_progress')}</Button>
      </Link>
    </div>
  );
}
